import MaterialIconsReact from 'material-icons-react';
import styles from './InfoMessage.module.css';

function InfoMessage(props) {
  return (
    <div className={styles.infoMessage}>
      <MaterialIconsReact icon={'info'} size={20} color={'#C17E22'} invert></MaterialIconsReact>
      <span className={styles.ml10}>{props.message}</span>
    </div>
  );
}

export default InfoMessage;